import * as React from 'react';

import { FilterIcon } from '@coursera/cds-icons';

import { Button } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-drawers';

import { FilterDrawer } from './FilterDrawer';
import AggregatedFilterBox from './components/AggregatedFilterBox';
import type { FilterCtrls, Filters } from './types';

export type Props = {
  filters: Filters;
  filterCtrls: FilterCtrls;
  onFiltersChange: (filters: Filters) => void;
  showAggregatedPills: boolean;
  maxVisibleFilters?: number;
};

type State = {
  filterDrawerOpen: boolean;
};

class FilterBox extends React.Component<Props, State> {
  state: State = {
    filterDrawerOpen: false,
  };

  handleFilterDrawerOpen = () => {
    this.setState({ filterDrawerOpen: true });
  };

  handleFilterDrawerClose = () => {
    this.setState({ filterDrawerOpen: false });
  };

  render() {
    const { filterDrawerOpen } = this.state;
    const { onFiltersChange, filters, filterCtrls, showAggregatedPills, maxVisibleFilters } = this.props;

    return (
      <div className="rc-FilterBox horizontal-box align-items-vertical-center" data-pendo-guide="FilterBox">
        <Button label={_t('Filters')} variant="ghost" icon={<FilterIcon />} onClick={this.handleFilterDrawerOpen} />
        {showAggregatedPills ? (
          <AggregatedFilterBox
            filters={filters}
            filterCtrls={filterCtrls}
            onChange={onFiltersChange}
            onOpen={this.handleFilterDrawerOpen}
            maxVisibleFilters={maxVisibleFilters}
          />
        ) : null}
        <FilterDrawer
          {...this.props}
          open={filterDrawerOpen}
          onClose={this.handleFilterDrawerClose}
          onChange={onFiltersChange}
        />
      </div>
    );
  }
}

export default FilterBox;
